import { RGBAColor } from 'deck.gl';
import { Moment } from 'moment';
import { DateFormat, DTFormat } from './StaticVariable';

// 生成空得 GEOJSON 格式
export function createEmptyGeoJson(): GeoJSON.FeatureCollection {
  return {
    type: 'FeatureCollection',
    features: [],
  };
}

export function openInNewTab(url: string) {
  return window.open(url, '_blank', 'noopener,noreferrer');
}

export const MIKE_DATE_FORMAT = 'DD MMM yyyy';
export const MIKE_DATETIME_FORMAT = 'DD MMM yyyy h:mm';

export function nicelyFormatDate(date: Moment, includeTime = false) {
  return includeTime
    ? date.format(MIKE_DATETIME_FORMAT)
    : date.format(MIKE_DATE_FORMAT);
}

export function formatDate(date: Moment, includeTime = false) {
  return includeTime ? date.format(DTFormat) : date.format(DateFormat);
}

export function formatMonth(month: number) {
  let formattedMonth = 'All month';
  switch (month) {
    case 1:
      formattedMonth = 'Jan';
      break;
    case 2:
      formattedMonth = 'Feb';
      break;
    case 3:
      formattedMonth = 'Mar';
      break;
    case 4:
      formattedMonth = 'Apr';
      break;
    case 5:
      formattedMonth = 'May';
      break;
    case 6:
      formattedMonth = 'Jun';
      break;
    case 7:
      formattedMonth = 'Jul';
      break;
    case 8:
      formattedMonth = 'Aug';
      break;
    case 9:
      formattedMonth = 'Sep';
      break;
    case 10:
      formattedMonth = 'Oct';
      break;
    case 11:
      formattedMonth = 'Nov';
      break;
    case 12:
      formattedMonth = 'Dec';
      break;
    default:
      break;
  }
  return formattedMonth;
}

export function ConvertHexToRGBA(hex: string, transparent?: number) {
  hex = hex.replace('#', '');
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  if (transparent !== undefined) return [r, g, b, transparent] as RGBAColor;
  else return [r, g, b] as RGBAColor;
}

export function AddTransparencyToHexColor(hex: string, transparency: string) {
  const extract = hex.replace('#', '');
  return '#' + extract + transparency;
}

function ColorToHex(color: number) {
  const hexadecimal = color.toString(16);
  return hexadecimal.length == 1 ? '0' + hexadecimal : hexadecimal;
}

export function ConvertRGBtoHex(rgbaColor: RGBAColor) {
  return (
    '#' +
    ColorToHex(rgbaColor[0]) +
    ColorToHex(rgbaColor[1]) +
    ColorToHex(rgbaColor[2])
  );
}

export enum MethodWay {
  BC = 'BC',
  PP = 'PP',
  INV = 'INV',
}

export enum DownloadCheckboxKey {
  SW = 'SW',
  HD = 'HD',
  Wind = 'Wind',
}

export const selectedColor = '#00A4EC';

export const DatasetColors = ['#19506E'];

export const analyticsDefinitionSorted = [
  "Time Series Plot",
  "Rose Plot",
  "Scatter Plot",
  "Scatter Table",
  "Statistics",
  "Tidal Level",
  "Exceedance",
  "Histogram (w. Weibull Parameters)",
  "Persistence (Weather windows)",
  "Extreme Values",
];

// export const DatasetColors = [
//   '#d18700',
//   '#7199f0',
//   '#8fad6f',
//   '#b81c8e',
//   '#c687c8',
//   '#5ee1f6',
//   '#cf542b',
//   '#d0fbb8',
//   '#a7e68c',
//   '#5e8cbc',
//   '#af1203',
//   '#875802',
//   '#45873f',
//   '#d07676',
//   '#e4cd62',
//   '#a4a67c',
//   '#c3a1ff',
//   '#07a2b2',
//   '#3181b3',
//   '#d18700',
//   '#7199f0',
//   '#8fad6f',
//   '#b81c8e',
//   '#c687c8',
//   '#5ee1f6',
//   '#cf542b',
//   '#d0fbb8',
//   '#a7e68c',
//   '#5e8cbc',
//   '#af1203',
//   '#875802',
//   '#45873f',
//   '#d07676',
//   '#ff6347',
// ];

// export const LegendColors = [
//   "#FAFCD0",
//   "#F3F894",
//   "#EDF458",
//   "#D6EC2F",
//   "#AEDF45",
//   "#88D35A",
//   "#60C770",
//   "#49B580",
//   "#429F8A",
//   "#3B8994",
//   "#34739D",
//   "#305D9D",
//   "#2D4886",
//   "#2C3472",
//   "#2B1F5D",
//   "#290441"
// ]

// export const LegendColors = [
//   "#FFFFFE",
//   "#FAFCD0",
//   "#F3F894",
//   "#EDF458",
//   "#D6EC2F",
//   "#AEDF45",
//   "#88D35A",
//   "#60C770",
//   "#49B580",
//   "#429F8A",
//   "#3B8994",
//   "#34739D",
//   "#305D9D",
//   "#2D4886",
//   "#2B2C69",
//   "#290B48"
// ]

export const LegendColors = [
  '#FBE626',
  '#DEE130',
  '#B1D941',
  '#88D150',
  '#5DC861',
  '#4AB76E',
  '#3BA979',
  '#279787',
  '#23888D',
  '#2A798C',
  '#31698C',
  '#38598B',
  '#3C4A84',
  '#3F3876',
  '#412768',
  '#450E55',
];

export function openEULAPdf() {
  window.open(
    'https://www.metocean-on-demand.com/fileshare/getfile.ashx?type=license&file_name=DHI_Metocean_Data_Portal_EULA.pdf',
    '_blank'
  );
}

export function openPrivatePolicy() {
  window.open('https://www.dhigroup.com/privacy', '_blank');
}
